import { useRouter } from 'next/router'
import { useState, useEffect } from 'react'

export default function BlogOrder() {
  const router = useRouter()
  const [sortOrder, setSortOrder] = useState('newest')

  useEffect(() => {
    // Get sort order from URL on initial load
    const urlSort = router.query.sort as string
    if (urlSort) {
      setSortOrder(urlSort)
    }
  }, [router.query.sort])

  const handleSortChange = (newOrder: string) => {
    setSortOrder(newOrder)
    // Update URL with new sort order using shallow routing
    router.push({
      pathname: router.pathname,
      query: { ...router.query, sort: newOrder },
    }, undefined, { shallow: true })
  }

  return (
		<div className='BlogOrder flex items-center gap-6 text-[1.125rem]'>
			<span className='text-primary'>Order by:</span>
			<div className='flex items-center gap-4'>
				<button
					onClick={() => handleSortChange('newest')}
					className={`flex items-center gap-2 text-primary ${
						sortOrder === 'newest' ? 'font-medium' : 'text-neutral-400'
					} transition-colors`}
				>
					<span>Newest</span>
					<svg
						width='14'
						height='14'
						viewBox='0 0 14 14'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						className={`transform ${
							sortOrder === 'newest' ? 'font-medium' : 'text-neutral-400'
						}`}
					>
						<path
							d='M7 2.33334V11.6667'
							stroke='currentColor'
							strokeWidth='1.5'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
						<path
							d='M11.6666 7L6.99992 11.6667L2.33325 7'
							stroke='currentColor'
							strokeWidth='1.5'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
					</svg>
				</button>
				<button
					onClick={() => handleSortChange('oldest')}
					className={`flex items-center gap-2 text-primary ${
						sortOrder === 'oldest' ? 'font-medium' : 'text-neutral-400'
					} transition-colors`}
				>
					<span>Oldest</span>
					<svg
						width='14'
						height='14'
						viewBox='0 0 14 14'
						fill='none'
						xmlns='http://www.w3.org/2000/svg'
						className={`transform rotate-180 ${
							sortOrder === 'oldest' ? 'font-medium' : 'text-neutral-400'
						}`}
					>
						<path
							d='M7 2.33334V11.6667'
							stroke='currentColor'
							strokeWidth='1.5'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
						<path
							d='M11.6666 7L6.99992 11.6667L2.33325 7'
							stroke='currentColor'
							strokeWidth='1.5'
							strokeLinecap='round'
							strokeLinejoin='round'
						/>
					</svg>
				</button>
			</div>
		</div>
	)
} 